import type { LucideIcon } from 'lucide-react';
import { BanknoteIcon, CreditCardIcon, PhoneIcon, UsersIcon } from 'lucide-react';
import {
	BALANCES_SEARCH_FIELD_OPTIONS,
	BALANCES_SORT_OPTIONS,
	CARDS_SEARCH_FIELD_OPTIONS,
	CARDS_SORT_OPTIONS,
	CLIENTS_SEARCH_FIELD_OPTIONS,
	CLIENTS_SORT_OPTIONS,
	PHONES_SEARCH_FIELD_OPTIONS,
	PHONES_SORT_OPTIONS,
	type ClientsListType,
} from '@/entities/clients-filter.entity';

export type FilterSchema = 'client' | 'balance' | 'card' | 'phone';

export interface CategoryDef {
	id: ClientsListType;
	label: string;
	icon: LucideIcon;
	/** false = show tab but list is ComingSoon */
	ready: boolean;
}

export const CLIENTS_CATEGORIES: CategoryDef[] = [
	{ id: 'balances', label: 'Балансы', icon: BanknoteIcon, ready: true },
	{ id: 'clients', label: 'Клиенты', icon: UsersIcon, ready: true },
	{ id: 'cards', label: 'Карты', icon: CreditCardIcon, ready: true },
	{ id: 'phones', label: 'Номера', icon: PhoneIcon, ready: true },
];

export interface CategoryQueryConfig {
	searchFields: { value: string; label: string }[];
	sortFields: { value: string; label: string }[];
	filterSchema: FilterSchema;
	defaultSearchField: string;
	defaultSortBy: string;
}

export const CATEGORY_QUERY_CONFIG: Record<ClientsListType, CategoryQueryConfig> = {
	clients: {
		searchFields: CLIENTS_SEARCH_FIELD_OPTIONS,
		sortFields: CLIENTS_SORT_OPTIONS,
		filterSchema: 'client',
		defaultSearchField: 'id',
		defaultSortBy: 'createdAt',
	},
	balances: {
		searchFields: BALANCES_SEARCH_FIELD_OPTIONS,
		sortFields: BALANCES_SORT_OPTIONS,
		filterSchema: 'balance',
		defaultSearchField: 'clientId',
		defaultSortBy: 'createdAt',
	},
	cards: {
		searchFields: CARDS_SEARCH_FIELD_OPTIONS,
		sortFields: CARDS_SORT_OPTIONS,
		filterSchema: 'card',
		defaultSearchField: 'cardNumber',
		defaultSortBy: 'createdAt',
	},
	phones: {
		searchFields: PHONES_SEARCH_FIELD_OPTIONS,
		sortFields: PHONES_SORT_OPTIONS,
		filterSchema: 'phone',
		defaultSearchField: 'number',
		defaultSortBy: 'createdAt',
	},
};

export function getCategoryConfig(listType: ClientsListType): CategoryQueryConfig {
	return CATEGORY_QUERY_CONFIG[listType];
}
